import { appSettings } from '@/appSettings';
import { useLoginStore } from '@/login/stores/useLoginStore';
import { storeToRefs } from 'pinia';

let _startdeliverInitialized = false;

type UseStartdeliverReturn = {
    init: () => void;
    event: (eventName: string) => void;
};

export function useStartdeliver(): UseStartdeliverReturn {
    const { instanceUserId, isSupport } = storeToRefs(useLoginStore());

    function init(): void {
        if (_startdeliverInitialized) return;
        if (appSettings.startdeliverApiKey == null) return;

        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        window.startdeliver = window.startdeliver ?? function () {
            (window.startdeliver.q = window.startdeliver.q ?? []).push(arguments);
        };

        const scriptElement = document.createElement('script');
        scriptElement.async = true;
        scriptElement.src = 'https://startde.live/r.js';

        const scripts = document.getElementsByTagName('script');

        if (scripts.length === 0) {
            document.head.appendChild(scriptElement);
            _startdeliverInitialized = true;
            return;
        }

        const firstScript = document.getElementsByTagName('script')[0];

        if (firstScript.parentNode != null) {
            firstScript.parentNode.insertBefore(scriptElement, firstScript);
            _startdeliverInitialized = true;
        }

        if (window.startdeliver == null) {
            console.error('Failed to load startdeliver');
            return;
        }

        window.startdeliver('initialize', appSettings.startdeliverApiKey);
    }

    function event(eventName: string): void {
        if (!appSettings.enableStartdeliver) return;
        if (isSupport.value) return;

        if (!_startdeliverInitialized) return;
        if (instanceUserId.value == null) return;
        if (window.startdeliver == null) return;

        console.info(`Sending startdeliver event: ${eventName}`);

        window.startdeliver('sendEvent', {
            userId: instanceUserId.value.replace(/-/g, ''),
            usageType: eventName,
            startdeliverUserFieldToMatchOn: 'uuid'
        });
    }

    return {
        init,
        event
    };
}
